import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../useAxios"
import { useTranslation } from "react-i18next";
import { App } from "antd";

export const useEditUser = () => {

    const axios = useAxios();
    const queryClient = useQueryClient();
    const {t} = useTranslation();
    const {message} = App.useApp();

    const editUser = async (user: any) => {
        try {
            await axios.put(`/api/user/${user.id}`, user);
        } catch (error) {
            throw new Error(t("messages.error.editUser"));
        }
    }

    return useMutation({
        mutationFn: editUser,
        onSuccess: (data) => {
            console.log(data);
            
            queryClient.invalidateQueries({ queryKey: ["users"] });
            message.success(t("messages.success.editUser"));
        },
    });
}